<template>
    <div class="page">
        <!--<div class="page-hd">-->
            <!--<myNav>{{title}}</myNav>-->
        <!--</div>-->
        <div class="page-bd">
            <Button type="primary" @click="openAdd">{{$t("add_role2")}}</Button>
            <Button type="primary" @click="list()">{{$t("rfs")}}</Button>
            <div class="tree-box">
                <div v-for="item in listData" :key="item.role_id">
                    <span><Icon class="left-icon f-yellow" type="ios-ribbon" />{{item.role_cname}}
                        <span class="tag error fr" @click="delRole(item.role_id)">{{$t("del")}}</span>
                        <span class="tag warning fr" @click="openConfig(item)">{{$t("configure")}}</span>
                        <span class="tag primary fr" @click="openSave(item)">{{$t("info")}}</span>
                        <span class="tag primary fr" @click="openAddUser(item)">{{$t("add_role_user")}}</span>
                    </span>
                    <div class="sub-tree c1">
                        <div class="sub-tree c2" v-for="item2 in item.users" :key="item2.u_id">
                            <span><Icon class="left-icon f-green2" type="md-contact" />{{item2.user_cname}}
                                <span class="user-code-font">({{item2.user_code}})</span>
                                <span class="tag error" @click="removeUser(item.role_id,item2.u_id)">{{$t("remove")}}</span>
                            </span>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <Drawer class="drawer-sub-view" :title="sub_title" v-model="show_subview" width="720" :mask-closable="false" placement="left" :closable="false">
            <router-view></router-view>
        </Drawer>
    </div>
</template>

<script>
    import myNav from "../../../components/myNav"

    export default {
        name:"org-role",
        components:{
            myNav,
        },
        data:function(){
            return{
                title: this.$t('role'),
                sub_title:"",//子界面名称
                show_subview:false,
                relist:false,
                search:{
                    search_url:'role/list'
                },
                listTable: {},//表结构
                listData: [],
                totalData: {
                    total: 0,//总行数
                }
            }
        },
        activated:function(){
            this.$base.setMenuOpens();
        },
        mounted: function(){
            this.$base.setMenuOpens();
            this.list();
        },
        methods:{
            list: function () {
                this.$base.showLoading();
                this.$request.sendPost(this.search.search_url,this.search,(success,data,error)=>{
                    this.$base.hideLoading();
                    if(success){
                        this.listData = data;
                    }
                    else{
                        this.$base.alertErr(error.errmsg);
                    }
                });
            },
            openAdd:function () {
                this.sub_title = this.$t("add_role");
                this.$base.linkTo("/org/role/save");
            },
            openSave:function (item) {
                this.sub_title = this.$t("upd") + item.role_cname;
                this.$base.linkTo("/org/role/save",{data: JSON.stringify(item)});
            },
            openAddUser:function (item) {
                this.sub_title = item.role_cname + this.$t("add_user");
                this.$base.linkTo("/org/role/user",{data: JSON.stringify(item)});
            },
            openConfig:function (item) {
                this.sub_title = item.role_cname + this.$t('configure');
                this.$base.linkTo("/org/role/func",{data: JSON.stringify(item)});
            },
            //删除角色
            delRole: function (role_id) {
                let data = {
                    role_id: role_id
                };
                let content = this.$t('confirm_delete');
                let title =  this.$t('tips');
                this.$base.confirm(title,content, () => {
                    this.$base.showLoading();
                    this.$request.sendPost("role/del",data,(success,data,error)=>{
                        this.$base.hideLoading();
                        if(success){
                            this.list();
                        }
                        else{
                            this.$base.msgErr(error.errmsg)
                        }
                    });
                },()=>{})
            },
            removeUser: function (role_id,u_id) {
                let data = {
                    u_id: u_id,
                    role_id: role_id
                };
                let content = this.$t('confirm_delete');
                let title =  this.$t('tips');
                this.$base.confirm(title,content, () => {
                    this.$base.showLoading();
                    this.$request.sendPost("role/del-user",data,(success,data,error)=>{
                        this.$base.hideLoading();
                        if(success){
                            this.list();
                        }
                        else{
                            this.$base.msgErr(error.errmsg)
                        }
                    });
                },()=>{})
            }
        },
        watch:{
            //界面重新加载数据
            relist:function (newVal,oldVal) {
                if(newVal){
                    this.list(this.search.page);
                    this.relist = false;
                }
            }
        }
    }
</script>

<style scoped>
    .tree-box{
        max-width: 600px;
    }
</style>



// WEBPACK FOOTER //
// src/pages/org/role/role.vue